export default __webpack_public_path__ + "static/media/logo-header-white.1ddfbe12.png";